// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__McBzZ","summary":"AdvancePaymentDetails_summary__R1zWV","edit":"AdvancePaymentDetails_edit__ZpmzB"};